import { customSeriesDefaultOptions, CustomSeriesOptions, LineWidth } from 'lightweight-charts'
import { buyColor, red } from '../../../../assets/colors'


export enum PandFMarkerType {
    Elliipse,
    Cross
}

export interface PandFSeriesOptions extends CustomSeriesOptions {
    upColor: string,
    downColor: string,
    upMarker: PandFMarkerType,
    downMarker: PandFMarkerType,
    color: string;
    lineWidth: LineWidth,
    boxMethod: 'traditional' | 'atr' | 'percentage',
    boxSize: number,
    atrLength: number,
    percentage: number,
    reversalAmount: number
}

export const defaultPandFOptions: PandFSeriesOptions = {
    ...customSeriesDefaultOptions,
    upColor: buyColor,
    downColor: red,
    color: buyColor,
    upMarker: PandFMarkerType.Cross,
    downMarker: PandFMarkerType.Elliipse,
    lineWidth: 1,
    boxMethod: 'atr',
    boxSize: 1,
    atrLength: 14,
    percentage: 1,
    reversalAmount: 3
} as const